import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import seo from "@/seo/routes.json";

function setMeta(attr, key, value) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
}

function setOrRemove(selector, create, apply) {
  let el = document.head.querySelector(selector);
  if (!apply) return el && el.remove();
  if (!el) {
    el = create();
    document.head.appendChild(el);
  }
  apply(el);
}

export function useSeo() {
  const { pathname } = useLocation();
  useEffect(() => {
    const p = pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname;
    const known = !!seo.routes[p];
    const meta = seo.routes[p] || seo.notFound;
    const url = `${seo.site}${p}`;
    document.title = meta.title;
    setMeta("name", "description", meta.description);
    setMeta("name", "robots", meta.noindex ? "noindex, nofollow" : "index, follow");
    setMeta("property", "og:type", "website");
    setMeta("property", "og:site_name", "Olivia's Foundation");
    setMeta("property", "og:title", meta.title);
    setMeta("property", "og:description", meta.description);
    setMeta("property", "og:url", url);
    const image = `${process.env.REACT_APP_BACKEND_URL}${seo.image}`;
    setMeta("property", "og:image", image);
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", meta.title);
    setMeta("name", "twitter:description", meta.description);
    setMeta("name", "twitter:image", image);
    setOrRemove(
      'link[rel="canonical"]',
      () => Object.assign(document.createElement("link"), { rel: "canonical" }),
      known && !meta.noindex && ((el) => { el.href = url; }),
    );
    setOrRemove(
      'script[type="application/ld+json"]',
      () => Object.assign(document.createElement("script"), { type: "application/ld+json" }),
      p === "/" && ((el) => { el.textContent = JSON.stringify(seo.jsonLd); }),
    );
  }, [pathname]);
}
